import KdiagramCalculationResultData from "./data.js";
import mapFdmDataFromJson from "./fdm/mapper.js";
import mapTableDataFromJson from "./table_data/mapper.js";
import mapLineParametersFromJson from "./line_parameters/mapper.js";
import mapCalculationInputFromJson from "./calculation_input/mapper.js";

export default function mapKdiagramCalculationResultDataFromJson(json) {
  return new KdiagramCalculationResultData(
    mapFdmDataFromJson(json),
    mapTableDataFromJson(json),
    mapLineParametersFromJson(json),
    mapCalculationInputFromJson(json),
  );
}
